var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedotsX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_actions",
    "data-name": "more actions",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8257",
    "data-name": "Rectangle 8257",
    fill: "none",
    stroke: "#c4c4c4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 1.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_50316",
    "data-name": "Group 50316",
    transform: "translate(6350 19961)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2092",
    "data-name": "Ellipse 2092",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(-6336 -19952)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2093",
    "data-name": "Ellipse 2093",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(-6341 -19952)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2094",
    "data-name": "Ellipse 2094",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(-6346 -19952)",
    fill: "#606060"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedotsX);
export default __webpack_public_path__ + "static/media/threedots_x.4655bdf5c1a92a1fdf157e42a74cb666.svg";
export { ForwardRef as ReactComponent };